import { useState } from "react"
import "./Nav.css"
// import { Link } from "react-router-dom"

const Nav = ()=>
{
    const [open , setopen] = useState(false)
    return(
        <div className="nav">
            <div className="title">
                <a href="#home"><h1>Port<span>folio</span></h1></a>
            </div>

            <ul className={open ? "active" : ""}>
                <li onClick={()=>setopen(!open)}><a href="#home">Home</a></li>
                <li onClick={()=>setopen(!open)}><a href="#about">About</a></li>
                <li onClick={()=>setopen(!open)}><a href="#skills">Skills</a></li>
                <li onClick={()=>setopen(!open)}><a href="#projects">Projects</a></li>
                <li onClick={()=>setopen(!open)}><a href="#contact">Contact</a></li>

            </ul>

            <div className="icon" onClick={() => setopen(!open)}>
                <i className="fa-solid fa-bars"></i>
            </div>
        </div>   
    )
}

export default Nav